import script from "./ExcludedClients.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExcludedClients.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__